import {
    Leasing_TenantOverview_Dynamics_Widget_Reducer_Values,
    increaseShoudUpdateMetricsCounter,
    storeRawMetricsData,
} from '../reducer';
import { TServerResponse, handleServerResponse } from '../../../../../../../../tools/API/handleServerResponse';
import { useDispatch, useSelector } from 'react-redux';

import { cabinetPreferencesValues } from '../../../../../../CabinetPreferences/reducer';
import { generalReducerValues } from '../../../../../../../../General.reducer';
import generateQueryData from '../tools/generateQueryData';
import responseAnalyzer from '../../../../../../../../tools/API/responseAnalyzer';
import { Leasing_TenantOverview_Module_Reducer_Values } from '../../../reducer';
import { useEffect } from 'react';
import { useRequestMetrics } from '../../../../../../../../tools/API/useRequestMetrics';
import { useTranslation } from 'react-i18next';
import { useWidgetCurrentOptions } from '../../../../../../../../tools/useWidgetCurrentOptions';

/**
 * Кастомный хук для получения метрик с сервера
 */
export const useGetMetrics = () => {
    const fetchData = useRequestMetrics();
    const { moduleName } = useSelector(Leasing_TenantOverview_Module_Reducer_Values);
    const localCurrentOptions = useWidgetCurrentOptions(moduleName);
    const { token } = useSelector(generalReducerValues);
    const {
        shoudUpdateMetricsCounter,
        extendedReportingObjects,
        selectedChartDetailing,
        selectedChartType,
        extendedMetrics,
        selectedMetric,
        selectedObject,
        dataRefetchObject,
    } = useSelector(Leasing_TenantOverview_Dynamics_Widget_Reducer_Values);
    const {
        preferences: { metricLevel },
    } = useSelector(cabinetPreferencesValues);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    // Инициирует перезапрос метрик, если изменился период сравнения на вкладке Периодов
    useEffect(() => {
        if (selectedChartType.id === 'periods' && localCurrentOptions?.comparePeriods) {
            dispatch(increaseShoudUpdateMetricsCounter());
        }
    }, [localCurrentOptions?.comparePeriods]);

    useEffect(() => {
        if (!localCurrentOptions) return;
        const controller = new AbortController();
        const signal = controller.signal;

        if (
            localCurrentOptions.comparePeriods &&
            localCurrentOptions.mainPeriod &&
            selectedChartDetailing &&
            selectedObject &&
            selectedMetric
        ) {
            const queryData = generateQueryData({
                compareDateRanges: localCurrentOptions.compareDateRanges,
                mainDateRanges: localCurrentOptions.mainDateRanges,
                comparePeriods: localCurrentOptions.comparePeriods,
                mainPeriod: localCurrentOptions.mainPeriod,
                extendedReportingObjects,
                selectedChartDetailing,
                selectedChartType,
                extendedMetrics,
                selectedObject,
                selectedMetric,
                metricLevel,
                token,
            }).map((item) => {
                return { ...item, signal };
            });

            dispatch(storeRawMetricsData({ status: 'Loading', message: t('Loading...') }));
            fetchData(queryData).then((res: TServerResponse) => {
                handleServerResponse({
                    responseAnalyzer: responseAnalyzer,
                    success: storeRawMetricsData,
                    error: storeRawMetricsData,
                    dispatch,
                    res,
                });
            });
        }

        return () => {
            controller.abort();
        };
    }, [
        localCurrentOptions?.mainPeriod,
        selectedChartDetailing?.id,
        shoudUpdateMetricsCounter,
        selectedChartType,
        selectedMetric,
        dataRefetchObject,
        selectedObject,
    ]);
};
